import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="/images/hero.jpeg"
          alt="東洋医学の自然美"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-forest-900/85 via-forest-800/65 to-forest-700/30" />
        <div className="absolute inset-0 bg-gradient-to-b from-forest-900/30 via-transparent to-forest-900/40" />
      </div>

      {/* Decorative ripple circles (wave motif) */}
      <div className="absolute right-[8%] top-1/2 -translate-y-1/2 pointer-events-none hidden lg:block">
        <div className="relative w-80 h-80 opacity-10">
          <div className="absolute inset-0 rounded-full border border-cream-200" />
          <div className="absolute inset-8 rounded-full border border-cream-200" />
          <div className="absolute inset-16 rounded-full border border-cream-200" />
          <div className="absolute inset-24 rounded-full border border-cream-200" />
          <div className="absolute inset-32 rounded-full border border-cream-200" />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 pt-20">
        <div className="max-w-2xl">
          {/* Label */}
          <div className="flex items-center gap-4 mb-8">
            <div className="w-12 h-px bg-cream-400/60" />
            <span className="text-cream-400/80 text-xs font-serif tracking-widest2 uppercase">
              Oriental Medicine Future Expand Society
            </span>
          </div>

          {/* Catch copy */}
          <h1 className="text-cream-100 font-serif font-light leading-snug mb-8">
            <span className="block text-4xl md:text-5xl lg:text-6xl tracking-wider">東洋医学の未来を、</span>
            <span className="block text-4xl md:text-5xl lg:text-6xl tracking-wider mt-2">共にかたちに。</span>
          </h1>

          {/* Sub copy */}
          <p className="text-cream-300/80 text-sm md:text-base font-serif font-light leading-relaxed tracking-wide max-w-lg mb-10">
            施術者、企業、団体が連携し、学術・臨床・産業の垣根を越えた取り組みを通じて、
            東洋医学の未来を推進してまいります。
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/about"
              className="px-8 py-3.5 bg-forest-600 text-cream-100 text-sm font-serif tracking-widest rounded-sm hover:bg-forest-500 transition-colors duration-200 text-center whitespace-nowrap cursor-pointer"
            >
              協会について
            </Link>
            <Link
              to="/membership"
              className="px-8 py-3.5 border border-cream-400/60 text-cream-200 text-sm font-serif tracking-widest rounded-sm hover:bg-cream-200/10 transition-colors duration-200 text-center whitespace-nowrap cursor-pointer"
            >
              入会案内
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-60">
        <span className="text-cream-400 text-xs font-serif tracking-widest2">SCROLL</span>
        <div className="w-px h-12 bg-gradient-to-b from-cream-400 to-transparent animate-pulse" />
      </div>
    </section>
  );
}
